import { useCallback } from 'react';

import { useWallet, type WalletName } from '@aptos-labs/wallet-adapter-react';

import { useToastStore } from '@pkg/components';

export function usePetraWallet() {
    const { addToast } = useToastStore();
    const { connect, connected, account, signMessage, wallet, wallets } = useWallet();

    const handlePetraConnect = useCallback(async () => {
        if (wallets?.[0] && wallets[0]?.name === 'Petra' && wallets?.[0]?.readyState === 'NotDetected') {
            addToast({
                message: `Please make sure you have Petra Wallet installed.`,
                minimal: true,
            });

            window.location.href = 'https://petra.app/';
        } else {
            if (!connected || !account) {
                try {
                    await connect(wallet?.name || ('Petra' as WalletName));
                } catch (error) {
                    if (error == 'No accounts found') {
                        addToast({
                            message: `Account not found.`,
                            minimal: true,
                        });
                    }
                }
            }
            return account;
        }
    }, [account, connect, connected, wallet?.name, addToast, wallets]);

    return { handlePetraConnect, signMessage };
}
